export const EXPO_48_INTERESTS = [
  { value: "semi_detach", label: "Semi-detach บ้านเดี่ยว" },
  { value: "townhouse", label: "Townhouse/townhome/home office ทาวน์เฮ้าส์/ทาวน์โฮม/โฮออฟฟิศ" },
  { value: "condo", label: "Condominium คอนโดมิเนียม" },
  { value: "second_hand", label: "Second-hand บ้านมือ 2" },
  { value: "furniture", label: "Furniture สินค้าเบ็ดเตล็ด/เฟอร์นิเจอร์" },
  { value: "other", label: "Others อื่นๆ ระบุ" },
];

export const EXPO_48_BANKS = [
  "ธนาคารอาคารสงเคราะห์",
  "ธนาคารกสิกรไทย จำกัด (มหาชน)",
  "ธนาคารกรุงไทย จำกัด (มหาชน)",
  "ธนาคารกรุงเทพ จำกัด (มหาชน)",
  "ธนาคารออมสิน",
  "ธนาคารกรุงศรีอยุธยา จำกัด (มหาชน)",
  "ธนาคารทหารไทยธนชาต จำกัด (มหาชน)",
  "ธนาคารซีไอเอ็มบี ไทย จำกัด (มหาชน)",
  "ธนาคารไทยพาณิชย์ จำกัด (มหาชน)",
  "ธนาคารยูโอบี จำกัด (มหาชน)",
  "ธนาคารทิสโก้ จำกัด (มหาชน)",
  "ธนาคารเกียรตินาคินภัทร จำกัด (มหาชน)",
  "ธนาคารแลนด์ แอนด์ เฮ้าส์ จำกัด (มหาชน)",
  "ธนาคารอิสลามแห่งประเทศไทย",
  "ไม่สนใจสินเชื่อ / Not interested in financing",
  "อื่นๆ / Other",
];

export const EXPO_48_CHARACTERISTICS = [
  { value: "studio", label: "Studio สตูดิโอ" },
  { value: "1bed", label: "1 Bedroom 1 ห้องนอน" },
  { value: "2bed", label: "2 Bedroom 2 ห้องนอน" },
  { value: "3bed_plus", label: "3 Bedroom or more 3 ห้องนอนขึ้นไป" },
];

export const EXPO_48_PURCHASE_YEARS = [
  { value: "now", label: "Now ซื้อภายในงาน" },
  { value: "1_6_months", label: "1-6 months 1-6 เดือน" },
  { value: "6_12_months", label: "6-12 months 6-12 เดือน" },
  { value: "1_2_years", label: "1-2 years 1-2 ปี" },
  { value: "2_plus_years", label: "2+ years 2 ปีขึ้นไป" },
];

export const EXPO_48_PRICE_RANGES = [
  { value: "under_1m", label: "Not exceeding 1M ไม่เกิน 1 ล้านบาท" },
  { value: "1.1_2m", label: "1.1-2M ล้านบาท" },
  { value: "2.1_3m", label: "2.1-3M ล้านบาท" },
  { value: "3.1_4m", label: "3.1-4M ล้านบาท" },
  { value: "4.1_6m", label: "4.1-6M ล้านบาท" },
  { value: "6.1_10m", label: "6.1-10M ล้านบาท" },
  { value: "10m_plus", label: "10M or more ล้านบาทขึ้นไป" },
];

export const EXPO_48_DEVELOPERS = [
  "บริษัท กานดา พร็อพเพอร์ตี้ จำกัด",
  "บริษัท จัซแมทช์ จำกัด",
  "บริษัท จันทราภา จำกัด",
  "บริษัท ซีคอน จำกัด",
  "บริษัท ทีซี เรียล แอสเซ็ท จำกัด",
  "บริษัท นิชดา พร็อพเพอร์ตี้ จำกัด",
  "บริษัท บริหารสินทรัพย์ อัลฟาแคปปิตอล จำกัด",
  "บริษัท บริหารสินทรัพย์ เจ จำกัด",
  "บริษัท ปัญจพล พร็อพเพอร์ตี้ จำกัด",
  "บริษัท พญาส์ อินเตอร์เนชั่นแนล จำกัด",
  "บริษัท พรูเด้นท์ พร็อพเพอร์ตี้ จำกัด",
  "บริษัท พร็อพเพอร์ตี้ อ๊อคชั่น เฮ้าส์ จำกัด",
  "บริษัท พร็อพเลน จำกัด",
  "บริษัท พฤกษา เรียลเอสเตท จํากัด (มหาชน)",
  "บริษัท ฟิวเจอร์เทค อินเตอร์มาร์เก็ตติ้ง จำกัด",
  "บริษัท รินไน (ประเทศไทย) จำกัด",
  "บริษัท ลลิล พร็อพเพอร์ตี้ จำกัด (มหาชน)",
  "บริษัท ศุภาลัย จำกัด (มหาชน)",
  "บริษัท สถาพร เอสเตท จำกัด",
  "บริษัท อนันดา ดีเวลลอปเม้นท์ จำกัด (มหาชน)",
  "บริษัท ออพติโม พร็อพเพอร์ตี้ จำกัด",
  "บริษัท ออริจิ้น พร็อพเพอร์ตี้ จำกัด (มหาชน)",
  "บริษัท ออเนอร์ แอสเสท ดีเวลลอปเม้นท์ จำกัด",
  "บริษัท อาณา เอสเตท จำกัด",
  "บริษัท เจ้าพระยามหานคร จำกัด (มหาชน)",
  "บริษัท เซ็นทรัลพัฒนา เรซซิเด้นซ์ จำกัด",
  "บริษัท เดอะ เนสท์ พร็อพเพอร์ตี้ จำกัด",
  "บริษัท เดอะ แพนโดร่า ภูเก็ต จำกัด",
  "บริษัท เฟรนด์ลิฟท์ จำกัด",
  "บริษัท เอพี (ไทยแลนด์) จำกัด (มหาชน)",
  "บริษัท เอส ที เอ็ม เอส จำกัด",
  "บริษัท เอสซี แอสเสท คอร์ปอเรชั่น จำกัด (มหาชน)",
  "บริษัท เอเวอร์แลนด์ จำกัด (มหาชน)",
  "บริษัท แกรนด์ พี พรอพเพอร์ตี้ จำกัด",
  "บริษัท แสนสิริ จำกัด (มหาชน)",
  "บริษัท แอบโซลูท 65 จำกัด",
  "บริษัท แอล โฮม เช็ค จำกัด",
  "บริษัท แอสเซทไวส์ จำกัด (มหาชน)",
  "บริษัท โบ๊ทพัฒนา จำกัด",
  "บริษัท โอเชี่ยน พรอพเพอร์ตี้ จำกัด",
];

// Format phone number as user types: 0800000000 -> 080-000-0000
export const formatPhoneNumber = (value: string): string => {
  // Remove all non-digits
  const digits = value.replace(/\D/g, "");

  // Limit to 10 digits
  const limited = digits.slice(0, 10);

  // Format as 080-000-0000
  if (limited.length <= 3) return limited;
  if (limited.length <= 6) return `${limited.slice(0, 3)}-${limited.slice(3)}`;
  return `${limited.slice(0, 3)}-${limited.slice(3, 6)}-${limited.slice(6)}`;
};

// Format price with commas as user types: 3500000 -> 3,500,000
export const formatPriceWithCommas = (value: string): string => {
  // Remove all non-digits
  const digits = value.replace(/\D/g, "");

  // Return empty string if no digits
  if (!digits) return "";

  // Add commas for thousands
  return digits.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

// Strip commas and convert to number: "3,500,000" -> 3500000
export const stripCommasToNumber = (value: string): number => {
  const digits = value.replace(/\D/g, "");
  return digits ? Number(digits) : 0;
};

// Format number with commas for display: 3500000 -> "3,500,000"
export const formatNumberWithCommas = (value: number | undefined | null): string => {
  if (value === undefined || value === null) return "";
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
